import { z } from "zod";
import { agentAppEventSchema } from "./app-events.js";
import { appIdSchema } from "./identifiers.js";
import { agentActorSchema } from "./messages.js";
/**
 * Control-plane delivery of one app event to the Agent service's
 * authenticated internal intake. `eventId` is the stable delivery identity
 * (for operations, `operation:<id>`); repeated deliveries are idempotent.
 * A null actor is a platform change presented with the product label.
 */
export const agentAppEventDeliverySchema = z
    .object({
    schemaVersion: z.literal(1),
    eventId: z.string().regex(/^[a-z][a-z_]{0,39}:[0-9a-f-]{36}$/),
    appId: appIdSchema,
    actor: agentActorSchema.nullable(),
    event: agentAppEventSchema,
})
    .strict()
    .refine((delivery) => delivery.eventId === `operation:${delivery.event.operationId}`, { message: "Operation events use their operation identity", path: ["eventId"] });
export const agentAppEventDeliveryResultSchema = z
    .object({
    disposition: z.enum(["recorded", "duplicate", "no_conversation"]),
    messageId: z.uuid().nullable(),
})
    .strict();
//# sourceMappingURL=app-event-delivery.js.map